export enum SystemTag {
	deleted = 'st_deleted',
}

export function isSystemTag(tag: string) {
	return tag.indexOf('st_') === 0;
}
